/** M-WF-01 · Verifica automatica: avvisi da confermare (gli errori bloccano già nella compilazione). */
import React from "react";
import { AlertTriangle, ArrowLeft, ArrowRight } from "lucide-react";
import { SuiteButton } from "@/components/suite";
import { formatDateIT } from "@/foundation/formatting";

export function TimesheetVerifyPanel({ warnings, onBack, onContinue }) {
  const entries = Object.entries(warnings || {}).sort(([a], [b]) => a.localeCompare(b));
  return (
    <div className="space-y-4 rounded-lg border border-amber-200 bg-amber-50/40 p-5" data-testid="timesheet-verify-panel">
      <div className="flex items-start gap-3">
        <AlertTriangle className="mt-0.5 text-amber-600" size={20} />
        <div>
          <div className="font-semibold text-suite-neutral-900">Verifica completata: {entries.length} {entries.length === 1 ? "giornata da controllare" : "giornate da controllare"}</div>
          <div className="text-sm text-suite-neutral-600">Non sono errori: puoi proseguire se gli orari corrispondono al foglio presenze.</div>
        </div>
      </div>
      <ul className="max-h-[45vh] divide-y divide-amber-100 overflow-auto rounded-md border border-amber-100 bg-white text-sm">
        {entries.map(([date, list]) => (
          <li key={date} className="flex gap-4 px-3 py-2" data-testid={`timesheet-verify-${date}`}>
            <span className="w-24 shrink-0 font-mono text-suite-neutral-700">{formatDateIT(date)}</span>
            <span className="text-suite-neutral-600">{list.map((w) => w.message).join(" · ")}</span>
          </li>
        ))}
      </ul>
      <div className="flex justify-between">
        <SuiteButton variant="ghost" icon={ArrowLeft} onClick={onBack} data-testid="timesheet-verify-back">Torna a correggere</SuiteButton>
        <SuiteButton autoFocus iconRight={ArrowRight} onClick={onContinue} data-testid="timesheet-verify-continue">Ho controllato, vai all&apos;anteprima</SuiteButton>
      </div>
    </div>
  );
}

export default TimesheetVerifyPanel;
